module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"chartjs","commonjs2":"chartjs","amd":"chartjs","root":"Chart"}
// module id = 12
// module chunks = 0